import React from "react";

const PayLinks = () => {
  return (
    <div>
      <h1 className="text-white text-center rounded bg-dark m-1">Comming Soon...</h1>
      <img className="img-fluid rounded" src="https://img.freepik.com/free-vector/abstract-grunge-style-coming-soon-with-black-splatter_1017-26690.jpg?size=626&ext=jpg" alt=""/>
    </div>
  );
};

export default PayLinks;
